
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: {
      height: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column !important',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      overflow: 'scroll',
    }, 

});

export default styles;
export const useStyles = makeStyles(styles);
